import { Component, Input, OnInit } from '@angular/core';
import { ActiveOrderDsService } from '@app/core/data-services';
import { Quantity } from 'chronos-core-client';
import { AppSettingsQuery, knownUnits } from 'chronos-shared';

@Component({
  selector: 'app-sampling-estimation',
  templateUrl: './sampling-estimation.component.html',
  styleUrls: ['./sampling-estimation.component.scss']
})
export class SamplingEstimationComponent implements OnInit {
  @Input() public aqlSampleQuantity: Quantity;
  @Input() public tgsSampleQuantity: Quantity;
  public productionQuantity: number;
  public aqlPerPiecesSampleQuantity: Quantity;
  public tgsPerPiecesSampleQuantity: Quantity;
  public isAqlEnabled = false;
  public isTgsEnabled = false;

  constructor(private activeOrderDsService: ActiveOrderDsService) {}

  public ngOnInit(): void {
    const activeOrder = this.activeOrderDsService.getActiveOrder();
    this.productionQuantity = activeOrder.estimatedQuantity.value;

    this.aqlPerPiecesSampleQuantity = this.calculateSampleQuantity(this.productionQuantity, this.aqlSampleQuantity);
    this.tgsPerPiecesSampleQuantity = this.calculateSampleQuantity(this.productionQuantity, this.tgsSampleQuantity);

    this.isAqlEnabled = this.aqlSampleQuantity?.value > 0;
    this.isTgsEnabled = this.tgsSampleQuantity?.value > 0;
  }

  private calculateSampleQuantity(productionQuantity: number, sampleQuantity: Quantity): Quantity {
    const quantity = productionQuantity / (sampleQuantity.value || 1);
    const result = Math.ceil(quantity);
    return { value: result, unitId: sampleQuantity.unitId };
  }
}
